import type { PagedResultDto } from "@services/dto/pagedResultDto"
import propertyTypeService from "@services/master-data/propertyTypeService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class PropertyTypeStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    await propertyTypeService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    appDataStore.GetListPropertyType("")
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await propertyTypeService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await propertyTypeService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.GetListPropertyType("")
  }
  @action
  async get(id: number) {
    const result = await propertyTypeService.get(id)
    this.detailData = result
  }
  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async validateBeforeImport(file: File) {
    this.isLoading = true
    try {
      const result = await propertyTypeService
        .validateBeforeImport(file)
        .finally(() => (this.isLoading = false))
      const datas = result?.datas ?? result?.data ?? []
      const errors = result?.errors ?? []
      return { datas, errors }
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }

  @action
  async importPropertyType(datas: Array<{ id?: number; name?: string; nameEn?: string; code?: string; rowNumber?: number }>) {
    this.isLoading = true
    try {
      await propertyTypeService
        .importPropertyType(datas)
        .finally(() => (this.isLoading = false))
      appDataStore.GetListPropertyType("")
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default PropertyTypeStore
